import React, {
  Dispatch,
  RefObject,
  SetStateAction,
  createContext,
} from 'react';
import { ScrollableSource, TableHandle } from '@eas/common-web';
import { Department, WorkOrder } from '@models';
import { CalendarSource } from './calendar/calendar-data-source';
import { CalendarHandle } from './calendar/calendar-types';
import { DepartmentTableFilterSyncSignal } from './department-table-filter-sync';
import { ShowSelectedWorkOrdersTableFilterSyncSignal } from './show-selected-workorders-table-filter-sync';

type PlannerContextProps = {
  calendarSource: CalendarSource | null;
  workOrderSource: ScrollableSource<WorkOrder> | null;
  calendarRef: RefObject<CalendarHandle>;
  workOrderTableRef: RefObject<TableHandle<WorkOrder>>;
  highlightedWorkOrder?: WorkOrder;
  setHighlightedWorkOrder: Dispatch<SetStateAction<WorkOrder | undefined>>;
  departmentTableFilterSyncSignal?: DepartmentTableFilterSyncSignal;
  showSelectedWorkOrdersTableFilterSyncSignal?: ShowSelectedWorkOrdersTableFilterSyncSignal;
  lastAppliedShowSelectedSignalKey?: number;
  setLastAppliedShowSelectedSignalKey: (key?: number) => void;
  calendarWorkOrderTableFilterIds?: string[];
  setCalendarWorkOrderTableFilterIds: (ids?: string[]) => void;
  clearCalendarWorkOrderTableFilter: () => void;
  syncDepartmentTableFilter: (departments: Department[]) => void;
  showSelectedWorkOrdersInTable: (params: {
    ids: Array<WorkOrder['id']>;
    workOrderIds: Array<WorkOrder['workOrderId']>;
  }) => void;
};

export const PlannerContext = createContext<PlannerContextProps>({
  calendarSource: null,
  workOrderSource: null,
  calendarRef: React.createRef(),
  workOrderTableRef: React.createRef(),
  setHighlightedWorkOrder: () => {},
  syncDepartmentTableFilter: () => {},
  showSelectedWorkOrdersInTable: () => {},
  setLastAppliedShowSelectedSignalKey: () => {},
  setCalendarWorkOrderTableFilterIds: () => {},
  clearCalendarWorkOrderTableFilter: () => {},
  highlightedWorkOrder: undefined,
  departmentTableFilterSyncSignal: undefined,
  showSelectedWorkOrdersTableFilterSyncSignal: undefined,
  lastAppliedShowSelectedSignalKey: undefined,
  calendarWorkOrderTableFilterIds: undefined,
});
